<script setup lang="ts">
import { defineEmits, computed } from "vue";
import { useOperationStore } from "@/stores/operation";

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const custom = computed(() => operationStore.customData);
const emit = defineEmits(["notice"]);

const handleClick = () => {
  emit("notice", false);
};
</script>

<template>
  <div class="relative" style="z-index: 99">
    <div
      style="z-index: 99"
      class="relative w-full overflow-auto"
      v-if="custom?.notice && custom?.notice != '<div><br></div>'"
    >
      <div v-html="custom?.notice" />
    </div>
    <div v-else class="relative w-full h-full overflow-visible text-sm mb-4">
      <h1 class="text-center py-6 font-bold w-full text-xl">
        {{ $t("notices.form_title") }}
      </h1>
      <p v-html="$t('notices.form')" />
    </div>
  </div>
</template>
